import * as actions from "../actions/Type";
const intialState = {
  branch: {},
  list_branches: [],
  list_active_branches: [],
  view_edit_branch: {},
  password_agent: "",
  get_agent_by_branch: [],
  get_agent_by_name_branch: [],
  get_agent_by_todos: [],
  create_admin: {},
  get_admins_list: [],
  branch_obj_salary: {},
  // loading
  branch_status: false,
  todo_status: false,
};

const AdminReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.CREATE_ADMIN:
      return {
        ...state,
        create_admin: action.payload,
      };
    case actions.GET_LIST_ADMINS:
      return {
        ...state,
        get_admins_list: action.payload,
      };
    case actions.GET_LIST_Branches:
      return {
        ...state,
        list_branches: action.payload,
        branch_status: action.branch_status,
      };
    case actions.CREATE_Branch:
      return {
        ...state,
        branch: action.payload,
      };
    case actions.VIEW_PROFILE_Branch:
      return {
        ...state,
        view_edit_branch: action.payload,
      };
    case actions.UPDATEING_STATUS:
      return {
        ...state,
      };
    case actions.GET_LIST_ACTIVE_BRANCHES:
      return {
        ...state,
        list_active_branches: action.payload,
      };
    case actions.UPDATEING_Agent_PASSWORD_BY_ADMIN:
      return {
        ...state,
        password_agent: action.payload,
      };
    case actions.VIEW_DETAIL_OF_AGGENT_BRANCH:
      return {
        ...state,
        get_agent_by_branch: action.payload,
        branch_obj_salary: action.branch_obj_salary,
      };
    case actions.GET_AGENT_BY_NAME:
      return {
        ...state,
        get_agent_by_name_branch: action.payload,
      };
    case actions.CREATE_BRANCH_TODO_AGENT:
      return {
        ...state,
      };
    case actions.GET_REALESTATE_ADDTODO_TOAGENT:
      return {
        ...state,
        get_agent_by_todos: action.payload,
        todo_status: action.todo_status,
      };
    default:
      return { ...state };
  }
};

export default AdminReducer;
